var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div bb-checkout>\n<div ng-if=\"total.$has('new_payment')\">\n<h1 translate=\"PUBLIC_BOOKING.CHECKOUT.STEP_HEADING\"></h1>\n<div bb-include=\"public-booking/_templates/basket_item_summary\"></div>\n<h2 class=\"booking-form-header\" translate=\"PUBLIC_BOOKING.CHECKOUT.PAYMENT_DETAILS_HEADING\">\n</h2>\n<div class=\"bb-checkout-pay-button\">\n<div bb-payment-button class=\"btn btn-primary\" total=\"total\" bb=\"bb\" decide-next-page=\"decideNextPage\" value=\"PUBLIC_BOOKING.CHECKOUT.PAY_BTN\">\n</div>\n</div>\n</div>\n</div>\n";
var id1="public-booking/_templates/steps/checkout.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/_templates/steps/checkout.html
// module id = 137
// module chunks = 0